import {useEffect} from 'react';
import {useGlobalError} from './useGlobalError';

export const useHandleGlobalError = (handler: (error: Error) => void) => {
    const { errorSubject$ } = useGlobalError();
    useEffect(() => {
        const sub = errorSubject$.subscribe(handler);
        return () => sub.unsubscribe();
    }, [errorSubject$, handler]);
}
